import { atom } from 'jotai'

import { Access } from '../lib'
import * as s1 from './state.profile'

// read-only derived atom
export const isBuyerAtom = atom(
	// getter
	(get) => {
		const profile = get(s1.profileAtom)
		const $access = new Access(profile)
		const isBuyer: boolean = $access.$account()?.extra?.isBuyer ?? false
		const accountId: number | null = $access.$account()?.id ?? null
		return isBuyer ? accountId : null
	}
)
